import { Link, NavLink, Outlet } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sparkles } from 'lucide-react';

export function MarketingLayout() {
  return (
    <div className="min-h-dvh bg-aurora">
      <header className="sticky top-0 z-40 border-b border-border/50 bg-background/70 backdrop-blur">
        <div className="container flex h-16 items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-lg font-semibold tracking-tight">
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-md bg-primary/15 text-primary">
              <Sparkles className="h-4 w-4" />
            </span>
            BG<span className="text-primary">Swap</span>
          </Link>
          <nav className="hidden items-center gap-6 text-sm text-muted-foreground md:flex">
            <NavLink to="/" end className={({ isActive }) => (isActive ? 'text-foreground' : 'hover:text-foreground')}>
              Overview
            </NavLink>
            <a href="#pricing" className="hover:text-foreground">Pricing</a>
            <NavLink to="/docs" className={({ isActive }) => (isActive ? 'text-foreground' : 'hover:text-foreground')}>
              Docs
            </NavLink>
          </nav>
          <div className="flex items-center gap-2">
            <Button asChild variant="ghost" size="sm">
              <Link to="/login">Sign in</Link>
            </Button>
            <Button asChild size="sm">
              <Link to="/login">Get started</Link>
            </Button>
          </div>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="border-t border-border/50 py-8">
        <div className="container flex flex-col items-center justify-between gap-2 text-xs text-muted-foreground md:flex-row">
          <div>© {new Date().getFullYear()} BGSwap · Clickingspree</div>
          <div className="flex gap-4">
            <Link to="/docs" className="hover:text-foreground">Docs</Link>
            <a href="mailto:chad@clickingspree.com" className="hover:text-foreground">Contact</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
